import LiveBackground, { useLiveBackground } from "../../liveBackground/LiveBackground";
import {convertStrToArr, splitArrayToStrings} from "../../../constant/General";
import {getDateTime} from "../../../utility/dateUtils";
import React, {memo, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {configSc, drawingV2} from "../../../constant/initDrawing";
import Welcome from "../Welcome";
import Loading from "../../results/loading";
import Random from "../../results/random";
import loading from "../../../assets/images/live-v2/gif/loading.gif";
import _ from "lodash";
import LayoutWrapper from "../mt/LayoutWrapper";
import ContentWrapper from "../mt/ContentWrapper";

const config = {
    ...configSc, style: {
        ...configSc.style,
        drawing: {
            ...configSc.style.drawing,
            color: "#000000",
            width: "110px",
            height: "117px",
            paddingLeft: "10px",
            letterSpacing: "unset",
            marginLeft: "unset"
        },
        random: {
            ...configSc.style.random,
            color: "#000000",
            width: "110px",
            height: "117px",
            paddingLeft: "10px",
            letterSpacing: "unset",
            marginLeft: "unset"
        }
    }
};

const RenderResult = memo(({num}) => {
    const isNumber = !_.isNaN(parseInt(num));
    if (isNumber) {
        return <span
            style={config.style.drawing}>{num}</span>
    } else if (num === "?") {
        return <span style={config.style.random}><Random sizeDigit={num.length}/></span>;
    } else {
        return <span style={configSc.style.center}><Loading sizeDigit={num.length} style={{width: "80px"}} src={loading}
                                                            isArr={false}/></span>;
    }
});

const Live2Kh = ({socket}) => {
    const navigate = useNavigate();
    const backgroundType = useLiveBackground();
    const [result, setResult] = useState(drawingV2);

    useEffect(() => {
        socket.on("kh_result", (draw) => {
            setResult(draw);
        });

        return () => {
            socket.off("kh_result");
        }
    }, [socket]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw}/>

    return <LiveBackground result={result} className="d-flex justify-content-center overflow-hidden mt-2 live2-sc">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(backgroundType ? "/live-full" : "/")}
        >
            Back
        </button>
        <div>
            <div className="live-draw-heading d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    KH
                </span> {getDateTime(result?.drawAt)}</div>
            <LayoutWrapper>
                <ContentWrapper>
                    <div className="d-flex position-relative" style={{
                        ...config.style.wrapper,
                        backgroundImage: backgroundType
                            ? "none"
                            : `url(${require(`../../../assets/images/live-v2/kh/bg.jpg`)})`
                    }}>
                        <div style={{
                            ...config.style.container,
                            backgroundSize: "100% 100%",
                            backgroundImage: `url(${require(`../../../assets/images/live-v2/kh/drawing.png`)})`
                        }}>
                            <div style={{height: "766px", width: "100%", position: "relative"}}
                                 className="d-flex justify-content-center align-items-center">
                                <div style={{
                                    height: "614px", width: "710px", fontSize: "96px"
                                }}>
                                    <div
                                        className="w-100 h-100 d-flex flex-wrap justify-content-center align-content-between">
                                        {result.results.map((result, i) => {
                                            const {number} = result;
                                            const getResult = convertStrToArr(number);
                                            return <div
                                                className="d-flex justify-content-between align-items-center w-100"
                                                key={i}>
                                                {getResult.map((num, index) => {
                                                    return <div key={index} style={{
                                                        fontSize: "96px", width: "110px", height: "117px"
                                                    }}
                                                                className="d-flex justify-content-center align-items-center">
                                                        <RenderResult num={num}/>
                                                    </div>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div style={{
                            height: "766px",
                            width: "100%",
                            backgroundSize: "100% 100%",
                            backgroundImage: `url(${require(`../../../assets/images/live-v2/kh/post.png`)})`
                        }} className="d-flex justify-content-center align-items-center">
                            <div style={{height: "716px", marginLeft: "315px", position: "relative"}} className="">

                                <div className="h-100">
                                    {result.results.map((result, i) => {
                                        const {number} = result;
                                        const show = splitArrayToStrings(number)
                                        return <div
                                            style={{
                                                height: "141px",
                                                color: "#9C0000",
                                                fontSize: "130px",
                                                marginBottom: "50px"
                                            }}
                                            className="d-flex justify-content-center align-items-center" key={i}>
                                            <div className="d-flex justify-content-start align-items-center"
                                                 style={{
                                                     width: "144px", height: "108px", marginRight: "70px"
                                                 }}>{show[0]}</div>
                                            <div className="d-flex justify-content-start align-items-center"
                                                 style={{width: "214px", height: "108px"}}> {show[1]}</div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>

                    </div>
                </ContentWrapper>
            </LayoutWrapper>
        </div>
    </LiveBackground>
}

export default Live2Kh;
